import { cn } from "@/lib/utils";

interface TabsProps {
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export function Tabs({ children, className }: TabsProps) {
  return <div className={cn("", className)}>{children}</div>;
}

interface TabsListProps {
  children: React.ReactNode;
  className?: string;
}

export function TabsList({ children, className }: TabsListProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-lg border border-border bg-background/60 p-1",
        className
      )}
    >
      {children}
    </div>
  );
}

interface TabsTriggerProps {
  value: string;
  activeValue: string;
  onClick: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export function TabsTrigger({ value, activeValue, onClick, children, className }: TabsTriggerProps) {
  const active = value === activeValue;
  return (
    <button
      onClick={() => onClick(value)}
      className={cn(
        "rounded-md px-3 py-1.5 text-sm font-medium transition-all",
        active ? "bg-surface text-text-primary shadow-sm" : "text-text-muted hover:text-text-secondary",
        className
      )}
    >
      {children}
    </button>
  );
}
